import { gql } from '@apollo/client';

const QUERY = gql`
  query DivisionsAndTeams($seasonId: Int!) {
    showSeason(seasonId: $seasonId) {
      __typename
      id
      tsDivisionId
      defaultPaymentAccountId
      program {
        id
        name
      }
      divisions {
        id
        name
      }
      teams {
        id
        name
        divisionId
      }
    }
  }
`;

export const QUERY_WITH_DIVISIONS_AND_PROGRAM = gql`
  query ShowSeasonDivisions($seasonId: Int!) {
    showSeason(seasonId: $seasonId) {
      tsDivisionId
      defaultPaymentAccountId
      program {
        name
      }
      divisions {
        id
        name
      }
    }
  }
`;

export const QUERY_WITH_DIVISIONS = gql`
  query ShowSeasonDivisions($seasonId: Int!) {
    showSeason(seasonId: $seasonId) {
      id
      defaultPaymentAccountId
      divisions {
        id
        name
      }
    }
  }
`;

export default QUERY;
